<template>
	<button type="button" class="pay-item" @click="payOrder">付款 {{countText}}</button>
</template>


<script>
import moment from 'moment'
	export default {
		props: ['timer','payNo','index'],
    destroyed () {
		  if (this.counterTimer !== null) {
        clearInterval(this.timer)
        this.counterTimer = null;
        this.count = 0;
        this.endTime = undefined;
        this.countText = '';
      }
    },
		data(){
			return {
				countText: '',
				counterTimer: null,
				count: 0,
        endTime: undefined
			}
		},
		computed:{
			
		},
		methods: {
			payOrder(){
				let self = this;
        if (window.location.host == 'wap.blissmall.net') {
          window.location.href = window.location.origin+'/wx/?#/payTypes/'+self.payNo
        } else {
          self.$router.push({
            path: '/payTypes/'+self.payNo
          })

        }
			},
			timerOut(){
				if(this.index == undefined){
					this.$emit('timerOut');
				}else {
					this.$emit('timerOut',this.index);
				}
			},
      timerFunc ( self ) {

        var now = moment()
        self.count = self.endTime - now
        let timers = self.count

        let min = parseInt(timers/(1000*60));
        let sec = parseInt((timers - min*1000*60)/1000);

        min = min < 10 ? '0'+ min : min;
        sec = sec < 10 ? '0'+sec : sec;
        self.countText = min + ':' +sec;

        if(self.count < 0){
          self.timerOut();
          clearInterval(self.counterTimer);
          return false;
        }else {
          self.count -= 1000;
        }

      },
      setTimer () {
        let self = this;
        self.count = self.timer;
        if (self.timer == 0) {
          self.timerOut()
          return
        }

        if (self.endTime === undefined) {
          var newTime = moment().add(self.count / 1000,'seconds')
          self.endTime = newTime
        }

        self.timerFunc( self )
        self.counterTimer = setInterval(function () {
          var now = moment()
          self.count = self.endTime - now
          let timers = self.count

          let min = parseInt(timers/(1000*60));
          let sec = parseInt((timers - min*1000*60)/1000);

          min = min < 10 ? '0'+ min : min;
          sec = sec < 10 ? '0'+sec : sec;

          if(self.count < 0){
            self.timerOut();
            clearInterval(self.counterTimer);
            return false;
          }else {
            self.count -= 1000;
          }
          self.countText = min + ':' +sec;
        },1000);
      }

		},
		mounted(){
      console.log(this.timer);
		  this.setTimer()
		}

	}



</script>


<style lang="scss">
	@import '../../assets/css/mixin';
</style>


// WEBPACK FOOTER //
// countdown.vue?69170899